module.exports = __webpack_public_path__ + "static/media/file-icon.bcf0ef83.svg";